/**
 * Specialist finder block (blocks/specialist-finder.php): the region pills
 * filter the specialist cards by their clinics' location slugs
 * ([data-sf-regions], space-separated). "All" (empty value) shows every card.
 */

document.querySelectorAll( '[data-specialist-finder]' ).forEach( ( root ) => {
	const buttons = [ ...root.querySelectorAll( '[data-sf-region]' ) ];
	const cards = [ ...root.querySelectorAll( '[data-sf-regions]' ) ];

	buttons.forEach( ( button ) => {
		button.addEventListener( 'click', () => {
			const region = button.dataset.sfRegion;

			buttons.forEach( ( b ) => b.setAttribute( 'aria-pressed', String( b === button ) ) );
			cards.forEach( ( card ) => {
				const match = ! region || card.dataset.sfRegions.split( ' ' ).includes( region );
				card.hidden = ! match;
			} );
		} );
	} );
} );
